import { render, staticRenderFns } from "./SuccessPromo.vue?vue&type=template&id=1229be9f"
import script from "./SuccessPromo.vue?vue&type=script&lang=js"
export * from "./SuccessPromo.vue?vue&type=script&lang=js"
import style0 from "./SuccessPromo.vue?vue&type=style&index=0&id=1229be9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports